import React, {useState} from 'react';
import {Link} from "react-router-dom";
import {Avatar, Button, Divider, Fade, ListItemIcon, Menu, MenuItem, Typography} from "@mui/material";
import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import PermIdentityTwoToneIcon from '@mui/icons-material/PermIdentityTwoTone';

export function DropDownNavBarMenu({loggedIn, logoutFunction, loggedInUser}) {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    return (
        <div>
            <Button onClick={e => setAnchorEl(e.currentTarget)} sx={{ minWidth: 'auto', p: 0.5 }}>
                <Avatar sx={{
                    width: 36, height: 36,
                    background: 'linear-gradient(135deg, #1F2F42 0%, #C89E57 100%)',
                    fontSize: '0.875rem', fontWeight: 600,
                }}>
                    <PermIdentityTwoToneIcon sx={{ fontSize: '1.2rem' }}/>
                </Avatar>
            </Button>

            <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}
                TransitionComponent={Fade}
                PaperProps={{ sx: {
                    borderRadius: 3, mt: 1, minWidth: 200,
                    boxShadow: '0 10px 40px rgba(0,0,0,0.1)',
                    border: '1px solid rgba(0,0,0,0.06)',
                }}}>
                {loggedInUser?.attributes?.email && (
                    <MenuItem disabled sx={{ opacity: '0.7 !important' }}>
                        <Typography variant="caption">{loggedInUser.attributes.email}</Typography>
                    </MenuItem>
                )}
                <Divider/>
                <MenuItem component={Link} to="/billing" onClick={() => setAnchorEl(null)}
                    sx={{ borderRadius: 1, mx: 0.5, '&:hover': { background: 'rgba(99,102,241,0.06)' } }}>
                    <ListItemIcon sx={{ minWidth: 32 }}><VpnKeyIcon fontSize="small"/></ListItemIcon>
                    <Typography variant="body2">Billing</Typography>
                </MenuItem>
                <Divider/>
                {loggedIn ? (
                    <MenuItem onClick={() => { setAnchorEl(null); logoutFunction(); }}
                        sx={{ borderRadius: 1, mx: 0.5, '&:hover': { background: 'rgba(239,68,68,0.06)', color: 'error.main' } }}>
                        <ListItemIcon sx={{ minWidth: 32 }}><ExitToAppIcon fontSize="small"/></ListItemIcon>
                        <Typography variant="body2">Logout</Typography>
                    </MenuItem>
                ) : (
                    <MenuItem component={Link} to="/login" onClick={() => setAnchorEl(null)}
                        sx={{ borderRadius: 1, mx: 0.5 }}>
                        <ListItemIcon sx={{ minWidth: 32 }}><VpnKeyIcon fontSize="small"/></ListItemIcon>
                        <Typography variant="body2">Login</Typography>
                    </MenuItem>
                )}
            </Menu>
        </div>
    );
}
